<template>
  <div class="club-management container-fluid mt-4">
    <div class="row">
      <!-- Columna izquierda: Lista de clubes con buscador -->
      <div class="col-md-4 club-list bg-light p-3">
        <h2 class="text-center mb-3">Clubes</h2>
              <!-- boton nuevo club -->
              <button class="btn btn-primary w-100" @click="renderAltaClub">
                Nuevo Club
              </button>


        <input
          type="text"
          v-model="filtro"
          class="form-control mb-3"
          placeholder="Buscar club..."
        />
        <ul class="list-group">
          <li
            v-for="club in clubesFiltrados"
            :key="club.id"
            class="list-group-item d-flex justify-content-between align-items-center"
          >
            {{ club.nombre }}
            <div>
              <button class="btn btn-sm btn-outline-primary me-1" @click="renderVerClub(club)">
                Ver
              </button>
              <button class="btn btn-sm btn-outline-warning me-1" @click="renderEditarClub(club)">
                Editar
              </button>
              <button class="btn btn-sm btn-outline-danger" @click="borrarClub(club.id)">
                Eliminar
              </button>
            </div>
          </li>
        </ul>
      </div>

      <!-- Columna derecha: Componente dinámico -->
      <div class="col-md-8 club-detail">
        <component :is="componenteActual" 
            :club_id="club_id_seleccionado" 
            v-if="componenteActual" 
            @clubActualizado="renderVerClub"
            @clubCreado="renderVerClub"
        />
        <div v-else class="text-center">
          <p class="mt-5">Seleccione un club para ver o editar.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';
import VerClub from '@/components/Club/ver-club.vue';
import EditarClub from '@/components/Club/editar-club.vue';
import altaClub from './alta-club.vue';

export default {
  components: {
    VerClub,
    EditarClub,
    altaClub
  },
  data() {
    return {
      clubes: [],
      filtro: '',
      componenteActual: null, // 'VerClub' o 'EditarClub'
      club_id_seleccionado: null, // ID del club seleccionado
      clubActual: null,
    };
  },
  computed: {
    clubesFiltrados() {
      return this.clubes.filter((club) =>
        club.nombre.toLowerCase().includes(this.filtro.toLowerCase())
      );
    },
  },
  mounted() {
    this.obtenerClubes();
  },
  methods: {
    async obtenerClubes() {
      try {
        const response = await axios.get('/api/clubes');
        this.clubes = response.data;
      } catch (error) {
        console.error('Error al obtener la lista de clubes:', error);
      }
    },
    renderVerClub(club) {
      this.obtenerClubes();
      this.clubActual = club;
      this.club_id_seleccionado = club.id;
      this.componenteActual = 'VerClub';

    },
    renderEditarClub(club) {
      this.clubActual = club;
      this.club_id_seleccionado = club.id;
      this.componenteActual = 'EditarClub';

    },
    renderAltaClub(){
      this.componenteActual = 'altaClub';
    },
    async borrarClub(id) {
      if (confirm('¿Estás seguro de que deseas eliminar este club?')) {
        try {
          await axios.delete(`/api/clubes/${id}`);
          alert('Club eliminado con éxito');
          this.obtenerClubes();
        } catch (error) {

          alert(error.response.data.message);
          console.error('Error al borrar el club:', error.response.data.message);
        }
      }
    },
  },
};
</script>

<style scoped>
.club-management {
  background-color: #f7f8fa;
  min-height: 100vh;
}

.club-list {
  border-right: 1px solid #ddd;
}

.list-group-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.club-detail {
  padding: 20px;
  background-color: #fff;
  min-height: 100%;
  border-left: 1px solid #ddd;
}

.club-detail .text-center {
  color: #888;
}
</style>
